/** Turn @see item into a JSON string with the preferred indentation style. */
export function stringify(item: unknown): string {
  return JSON.stringify(item, null, 2);
}
